import React from 'react'
import { withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../../../utils/anchorScroll'

const LoginButton = ({ translationStore, history }) => {

  const onLoginButtonClick = async () => {
    history.location.state = { redirect: history.location.pathname }
    await anchorScroll('top', '/login')
  }

  return (
      <span onClick={onLoginButtonClick} className='cursor-pointer'>
        <button className='button button--white'>
          {/* {translationStore.translate('general_button_')} */}
          Anmelden
        </button>
      </span>
  )
}

export default withRouter(inject('translationStore')(observer(LoginButton)))



// WEBPACK FOOTER //
// ./src/components/Header/LoggedOffHeader/LoginButton.js